export enum ENUM__segmentation_model {
  NVIDIA_SEGFORMER_B0_512_512 = 'nvidia/segformer-b0-finetuned-ade-512-512',
}
